import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagSafeProps {}

const ColorTagSafe: React.FC<ColorTagSafeProps> = props => {
  return <ColorTag className="ColorTagSafe" color="green">Safe</ColorTag>
}

export default ColorTagSafe;